import { render, staticRenderFns } from "./DomTableHeader.vue?vue&type=template&id=7a003f70"
import script from "./DomTableHeader.vue?vue&type=script&lang=js"
export * from "./DomTableHeader.vue?vue&type=script&lang=js"
import style0 from "./DomTableHeader.vue?vue&type=style&index=0&id=7a003f70&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports